import { render, staticRenderFns } from "./relativa-pronomen.vue?vue&type=template&id=65b99694&scoped=true"
import script from "./relativa-pronomen.vue?vue&type=script&lang=js"
export * from "./relativa-pronomen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b99694",
  null
  
)

export default component.exports